import { ACTION_TYPES } from 'src/constants';

// Accounts
export function updateCredentials(payload) {
  return {
    type: ACTION_TYPES.UPDATE_CREDENTIALS,
    payload,
  };
}
